/**************************************************
 * Nombre:       Seccion_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     12 Hr
 **************************************************/
import {Button, Grid, useMediaQuery} from "@mui/material";
import {useObtenerColleccionTabla} from "../../Servicios/BD/useObtenerColleccionTabla";
import {useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_dialogos/Hooks/useDialogo";
import TituloNotificaciones from "../../Modulo_dashboard/ComponentesSecundarios/TituloNotificaciones";
import TablaBasica from "../../Modulo_tablas/Componentes/TablaBasica";
import {theme} from "../../Tema";
import {ESTADOTIENDAS} from "../../Constantes";
import {contarPropiedad} from "../../Servicios/BD/Contadores/contarPropiedad";
import {ManageSearch, MilitaryTech, TaskAlt} from "@mui/icons-material";
import Dialogo_Revision_Tienda from "../Dialogos/Dialogo_Revision_Tienda";
import Dialogo_Revision_Tienda_Aprobar from "../Dialogos/Dialogo_Revision_Tienda_Aprobar";
import {contarColeccion} from "../../Servicios/BD/Contadores/contarColeccion";
import Dialogo_Medalla from "../Dialogos/Dialogo_Medalla";

const Seccion_Medallas = () => {
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))
    const [numMedallas, setNumMedallas] = useState(0)
    const [recargar, setRecargar] = useState(false)
    const {props, cargarNuevamente} = useObtenerColleccionTabla({
        coleccion: 'medallas',
        filtroInicial: 'fecha',
        dirInicial: 'desc'
    })
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Medalla,
        realizado: () => setRecargar(!recargar),
        titulo: 'Detalles medalla'
    })

    const botones = [
        <Button
            color={'primary'}
            onClick={() => abrir()}
            startIcon={<MilitaryTech/>}
            variant={'contained'}>
            Nueva
        </Button>
    ]

    const manejardorClicks = (row, id) => {

        switch (id) {
            case 'ver' :
                abrir(row)
                break
        }

    }


    useEffect(() => {


        contarColeccion({coleccion: 'medallas'}).then((dox) => {
            if (dox.res) {
                setNumMedallas(dox.data)
            }
        })


        cargarNuevamente()

    }, [recargar]);
    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
        >

            <Dialogo/>

            <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'flex-start'}}>
                <TituloNotificaciones titulo={'Medallas'} textoComplementario={'en lista'}
                                      textoResaltado={`${numMedallas} Medallas`} difiere={true} botones={botones}/>
            </Grid>

            <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'flex-start', marginTop: 5}}>
                <TablaBasica
                    filtros={filtros}
                    datosCabecera={sCell ? datosCabeceraCell : datosCabecera}
                    {...props}
                    click={manejardorClicks}
                    botonesTabla={botonesTabla}
                    numeroFilas={numMedallas}
                />
            </Grid>


        </Grid>
    )

}
export default Seccion_Medallas

const filtros = [
    {
        nombre: 'Nombre',
        propiedad: 'nombre',

    },
    {
        nombre: 'Mas Reciente',
        propiedad: 'fecha',
        direccion: 'desc'

    }
]

const datosCabecera = [
    {
        nombre: 'Fecha',
        direccion: 'left',
        propiedad: 'fecha',
        tipo: 'fecha'

    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',

    },
    {
        nombre: 'Tipo',
        direccion: 'right',
        propiedad: 'tipo',

    }

]


const datosCabeceraCell = [
    {
        nombre: 'Fecha',
        direccion: 'left',
        propiedad: 'fecha',
        tipo: 'fecha'

    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',

    },
    {
        nombre: 'Estado',
        direccion: 'left',
        propiedad: 'estado',

    }
]


const botonesTabla = [
    {
        nombre: 'Ver Detalle',
        icono: ManageSearch,
        id: 'ver'
    }

]


